export enum Entity {
  House = 1,
  Business,
  GasStation,
  Interior,
  InteriorList,
  Address,
}
